import React from "react";
import { Grid, Skeleton } from "@mui/material";

const FormSkeleton: React.FC = () => {
  return (
    <Grid item container spacing={2}>
      <Grid item xs={3}>
        <Skeleton width="100%" height="56px" />
        <Skeleton width="100%" height="56px" />
        <Skeleton width="100%" height="56px" />
        <Skeleton width="100%" height="56px" />
      </Grid>
      <Grid item xs={6}>
        <Skeleton width="100%" height="56px" />
        <Skeleton width="100%" height="56px" />
        <Skeleton width="100%" height="56px" />
        <Skeleton width="100%" height="56px" />
      </Grid>
    </Grid>
  );
};

export default FormSkeleton;
